import React from 'react';
import LeftContainer from './LeftContainer';
import RightContainer from './RightContainer';
import './index.scss';

const AuthLayout: React.FC<{
  form: React.ReactNode;
  items: React.ReactNode;
  contextHolder?: any;
}> = ({ form, items, contextHolder }) => {
  return (
    <div className="auth-container">
      {contextHolder}
      <RightContainer items={items} />
      <LeftContainer form={form} />
    </div>
  );
};

export default AuthLayout;
